import { Injectable } from '@angular/core';
import { CourseInvite } from '../components/signup/course-invite';

@Injectable({
	providedIn: 'root'
})
export class SignupStateService {
	private courseInvite: CourseInvite | null = null;

	public setCourseInvite (invite: CourseInvite): void {
		this.courseInvite = invite;
	}

	public getCourseInvite (): CourseInvite | null {
		const invite = this.courseInvite;
		// Clear after reading so it's only used once
		this.courseInvite = null;
		return invite;
	}

	public clearCourseInvite (): void {
		this.courseInvite = null;
	}
}

